"use strict";

var _regeneratorRuntime = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _classCallCheck = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/createClass");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadPolygonMaskPlugin = void 0;

var PolygonMaskInstance_1 = require("./PolygonMaskInstance");

var PolygonMask_1 = require("./Options/Classes/PolygonMask");

var Enums_1 = require("./Enums");

var Utils_1 = require("../../Utils");

var Plugin =
/*#__PURE__*/
function () {
  function Plugin() {
    _classCallCheck(this, Plugin);

    this.id = "polygonMask";
  }

  _createClass(Plugin, [{
    key: "getPlugin",
    value: function getPlugin(container) {
      return new PolygonMaskInstance_1.PolygonMaskInstance(container);
    }
  }, {
    key: "needsPlugin",
    value: function needsPlugin(options) {
      var _a, _b, _c;

      return (_b = (_a = options === null || options === void 0 ? void 0 : options.polygon) === null || _a === void 0 ? void 0 : _a.enable) !== null && _b !== void 0 ? _b : ((_c = options === null || options === void 0 ? void 0 : options.polygon) === null || _c === void 0 ? void 0 : _c.type) !== undefined && options.polygon.type !== Enums_1.Type.none;
    }
  }, {
    key: "loadOptions",
    value: function loadOptions(options, source) {
      if (!this.needsPlugin(source)) {
        return;
      }

      var optionsCast = options;
      var polygonOptions = optionsCast.polygon;

      if ((polygonOptions === null || polygonOptions === void 0 ? void 0 : polygonOptions.load) === undefined) {
        optionsCast.polygon = polygonOptions = new PolygonMask_1.PolygonMask();
      }

      polygonOptions.load(source === null || source === void 0 ? void 0 : source.polygon);
    }
  }]);

  return Plugin;
}();

function loadPolygonMaskPlugin(_x) {
  return _loadPolygonMaskPlugin.apply(this, arguments);
}

function _loadPolygonMaskPlugin() {
  _loadPolygonMaskPlugin = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(tsParticles) {
    var plugin;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!(0, Utils_1.isSsr)() && !window.SVGPathSeg)) {
              _context.next = 3;
              break;
            }

            _context.next = 3;
            return Promise.resolve().then(function () {
              return __importStar(require("./pathseg"));
            });

          case 3:
            plugin = new Plugin();
            tsParticles.addPlugin(plugin);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _loadPolygonMaskPlugin.apply(this, arguments);
}

exports.loadPolygonMaskPlugin = loadPolygonMaskPlugin;